module.exports = __webpack_public_path__ + "img/class.7aec7365.png";